import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getTicketasignarmto } from '../../../redux/actions';
import CardContainer from "../AsignartecnicoMto/CardsContainer";
import PacmanLoader from 'react-spinners/PacmanLoader';
import { FaUserPlus } from 'react-icons/fa';
import styles from "./Card.module.css";
// Reuse global pro styles
import globalStyles from '../../../view/Tickets/GenerarTicket.module.css';

const AsignartecnicoMto = () => {
    const dispatch = useDispatch();
    const asignartec = useSelector((state) => state.ticketasignarmto);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadTickets = async () => {
            await dispatch(getTicketasignarmto());
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        };

        loadTickets();
    }, [dispatch]);

    return (
        <div className={globalStyles.container}>
            <header className={globalStyles.header}>
                <h2 className={globalStyles.title}>
                    <FaUserPlus style={{ marginRight: '15px' }} />
                    Asignar Técnico Mantenimiento
                </h2>
                <p className={globalStyles.subtitle}>
                    Gestiona la asignación de personal técnico para los requerimientos pendientes de mantenimiento.
                </p>
            </header>

            {loading ? (
                <div className={styles.pageSpinner}>
                    <PacmanLoader color="#8b5cf6" loading={loading} size={40} />
                    <p style={{ marginTop: '20px', color: '#64748b', fontWeight: '600' }}>Cargando solicitudes...</p>
                </div>
            ) : (
                <CardContainer asignartec={asignartec} />
            )}
        </div>
    );
};

export default AsignartecnicoMto;
